// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const InformationSm = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_8404_997)">
            <path d="M7.99996 5.03774H8.00737M7.99996 7.25941V10.9622M14.665 7.99996C14.665 11.681 11.681 14.665 7.99996 14.665C4.31899 14.665 1.33496 11.681 1.33496 7.99996C1.33496 4.31899 4.31899 1.33496 7.99996 1.33496C11.681 1.33496 14.665 4.31899 14.665 7.99996Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_8404_997">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
